export const getUserDetailsByUserId = /* GraphQL */ `
  query getUserDetailsByUserId($userId: String!) {
    getUserDetailsByUserId(userId: $userId) {
      id
      orderLineitemReplacement
      subscribeToNotification
      userId
    }
  }
`;
export const onCancelledOrderShipmentNotification = /* GraphQL */ `
  subscription onCancelledOrderShipmentNotification(
    $assignedStoreIds: [String]
  ) {
    onCancelledOrderShipmentNotification(assignedStoreIds: $assignedStoreIds) {
      orderId
      id
      userId
      assignedStoreId
      shipmentStatus
    }
  }
`;

export const listOrderShipments = /* GraphQL */ `
  query listOrderShipments(
    $filter: ModelOrderShipmentFilterInput
    $merchantAccountIdStatus: String
  ) {
    listOrderShipments(
      filter: $filter
      merchantAccountIdStatus: $merchantAccountIdStatus
    ) {
      items {
        id
        orderId
        deliveryType
        transportationType
        doordashInfo
        risk_level
        risk_score
        inNoSafeZone
        stripeInfo
        createdAt
        subOrderAmount
        subTotalServiceCharge
        subTotalCardProcessingFee
        shipmentLevelReplacementFee
        shipmentLevelReplacement
        totalPayableAmount
        subTotalAmount
        subTotalDiscount
        subTotalTaxAmount
        subTotalProductAmount
        shipmentStatus
        assignedStoreName
        assignedStoreId
        userId
        messageStatus
        clientInterface
        appliedPromoCode
        expiryDateTime
        promoCode_codeType
        scheduledDeliveryDt
        giftInstructions
        scheduledTimeSlot
        merchantAccountIdStatus
      }
    }
  }
`;

export const listFinancialReport = /* GraphQL */ `
  query listFinancialReport($merchantAccountId: String!) {
    listFinancialReport(merchantAccountId: $merchantAccountId) {
      items {
        assignedStoreId
        assignedStoreName
        dateRange
        reportPath
        invoicePath
        merchantAccountId
      }
    }
  }
`;

export const listOrderShipmentByStoreId = /* GraphQL */ `
  query listOrderShipmentByStoreId(
    $filter: ModelOrderShipmentFilterInput
    $storeId: ID!
  ) {
    listOrderShipmentByStoreId(filter: $filter, storeId: $storeId) {
      items {
        id
        orderId
        deliveryType
        createdAt
        subTotalServiceCharge
        subTotalCardProcessingFee
        shipmentLevelReplacementFee
        shipmentLevelReplacement
        totalPayableAmount
        subTotalAmount
        subTotalDiscount
        subTotalTaxAmount
        subTotalProductAmount
        shipmentStatus
        assignedStoreName
        assignedStoreId
        userId
      }
    }
  }
`;

export const onAddOrderShipment = /* GraphQL */ `
  subscription onAddOrderShipment($assignedStoreIds: [String]) {
    onAddOrderShipment(assignedStoreIds: $assignedStoreIds) {
      createdAt
      deliveryType
      id
      orderId
      subOrderAmount
      shipmentStatus
      assignedStoreName
      userId
      clientInterface
      appliedPromoCode
    }
  }
`;

export const listMerchantUsers = /* GraphQL */ `
  query listMerchantUsers(
    $filter: ModelMerchantUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMerchantUsers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        userId
        firstName
        middleName
        lastName
        email
        userRole
        phoneNumber
        stores {
          items {
            store {
              storeName
            }
          }
        }
      }
      nextToken
    }
  }
`;
export const listStoreCustomers = /* GraphQL */ `
  query listStoreCustomers($merchantAccountId: String $storeId: String $phoneNumber: String  $firstName: String $fullName: String) {
  listStoreCustomers(merchantAccountId: $merchantAccountId storeId:$storeId phoneNumber: $phoneNumber firstName: $firstName fullName: $fullName) {
      items {
        firstName
        lastName
        middleName
        storeName
        storeId
        email
        phoneNumber
        appliedPromoCodes
        merchantAccountId
         deliveryAddress{
        addrLine1
        addrLine2
        city
        country
        state
        postCode
     }
      }
    }
    }
  
`;

export const listStoreCustomerOrders = /* GraphQL */ `
  query listStoreCustomerOrders( $assignedStoreId: ID! $filter:ModelStoreCustomerOrderFilterInput) {
    listStoreCustomerOrders(assignedStoreId: $assignedStoreId filter: $filter) {
      items{
      id
      assignedStoreId
      orderId
      deliveryType
      shipmentStatus
      assignedStoreName
      orderLineItems {
        productName
        prodShortDesc
        qtyPurchased
        unitPrice
        totalPrice
        storeItemId
        salePrice
      }
      scheduledDeliveryDt
      
      scheduledTimeSlot
      updatedAt
      updatedBy
      subOrderAmount
      subTotalDeliveryCharges
      totalPayableAmount
      shipmentLevelReplacement
      giftInstructions
      shipmentLevelReplacementFee
      subTotal1800platformfee
      subTotalCardProcessingFee
      subTotalAmount
      subTotalDiscount
      subTotalSaleAmount
      subTotalProductAmount
      discountSubTotalProductAmount
      autoDiscount
      saleDiscount
      subTotalTaxAmount
      paymentIntentId
      stripeCustomerId
      phoneNumber
      subTotalTipAmount
      userId
      doordashInfo
      doorDashStatus
      transportationType
      appliedPromoCode
      couponCodeDiscount
      deliveryAddress {
        addrLine1
        addrLine2
        city
        country
        postCode
        state
      }
        }
    }
    }
  
`;

// this is an auto generated file. This will be overwritten
export const getMerchantUser = /* GraphQL */ `
  query getMerchantUser($userId: ID!) {
    getMerchantUser(userId: $userId) {
      userId
      firstName
      middleName
      lastName
      email
      phoneNumber
      isAlcoholAddendumReceived
      userRole
      profileImage
      address {
        addrLine1
        addrLine2
        city
        country
        state
        postCode
      }
      merchantAccount {
        id
        contactEmail
        contactName
        contactPhoneNumber
        companyName
        accountStatus
        brand_groupGeography
        brand_groupName
        in_geography
        in_brand_groupName
        isinbrand_group
        isabrand_group
        billingAddress {
          latitude
          city
          addrLine1
          addrLine2
          state
          country
          postCode
        }
        Stores {
          items {
            merchantAccountId
            storeName
            storeRefId
            isPaused
            isDeliveryPaused
            isShippingPaused
            isPickupPaused
            id
            destinationAccountID
            addLoyalCustomers
            storePhoneNumber
          }
        }
      }
    }
  }
`;

export const getCustomerUser = /* GraphQL */ `
  query getCustomerUser($firstName: String!) {
    getCustomerUser(firstName: $firstName) {
      userId
      firstName
      middleName
      lastName
      email
      phoneNumber
      isAlcoholAddendumReceived
      userRole
      profileImage
      address {
        addrLine1
        addrLine2
        city
        country
        state
        postCode
      }
      merchantAccount {
        id
        contactEmail
        contactName
        contactPhoneNumber
        companyName
        accountStatus
        brand_groupGeography
        brand_groupName
        in_geography
        in_brand_groupName
        isinbrand_group
        isabrand_group
        billingAddress {
          latitude
          city
          addrLine1
          addrLine2
          state
          country
          postCode
        }
        Stores {
          items {
            merchantAccountId
            storeName
            storeRefId
            isPaused
            isDeliveryPaused
            isShippingPaused
            isPickupPaused
            id
            storePhoneNumber
          }
        }
      }
    }
  }
`;

export const getOrderShipment = /* GraphQL */ `
  query getOrderShipment($id: ID!) {
    getOrderShipment(id: $id) {
      actionType
      assignedStoreId
      assignedStoreName
      createdAt
      discount
      deliveryType
      phoneNumber
      email
      giftInstructions
      clientInterface
      id
      orderId
      risk_level
      risk_score
      inNoSafeZone
      shipmentStatus
      messageStatus
      rejectionMsg
      isUpdated
      subTotalDiscount
      appliedPromoCode
      stripeCustomerId
      subTotalProductAmount
      subTotalServiceCharge
      subTotalCardProcessingFee
      shipmentLevelReplacementFee
      shipmentLevelReplacement
      scheduledDeliveryDt
      scheduledTimeSlot
      totalPayableAmount
      subTotalAmount
      subTotalTaxAmount
      # updatedAt
      updatedBy
      userId
      deliveryAddress {
        addrLine1
        addrLine2
        city
        country
        latitude
        longitude
        postCode
        state
      }
      refundIssuedAnytime
      refundSummary {
        orderLineItems {
          id
          prodShortDesc
          productId
          productName
          qtyPurchased
          size
          totalPrice
          unitPrice
          uom
          salePrice
          storePosName
          storeSizeUom
          storeDisplayQty
          storeItemId
          refundedQty
        }
        subTotalProductAmount
        subTotalTax
        subTotalTipAmount
        restockingFee
        subTotalDeliveryCharges
        subTotalCardProcessingFee
        amount
        updatedAt
      }
      orderLineItems {
        id
        upc
        prodShortDesc
        productId
        productName
        prodCategory
        imageSrc
        qtyPurchased
        size
        totalPrice
        unitPrice
        uom
        salePrice
        storePosName
        storeSizeUom
        storeDisplayQty
        storeItemId
        availableQty
      }
      statusHistory {
        fromStatus
        toStatus
        # updatedAt
        updatedBy
      }
      refunds {
        orderLineItems {
          id
          prodShortDesc
          productId
          productName
          qtyPurchased
          size
          totalPrice
          unitPrice
          uom
          salePrice
          storePosName
          storeSizeUom
          storeDisplayQty
          storeItemId
          refundedQty
        }
        subTotalProductAmount
        subTotalTax
        subTotalTipAmount
        restockingFee
        subTotalDeliveryCharges
        subTotalCardProcessingFee
        amount
        updatedAt
        refundId
        refundRes
        refundStatus
      }
      subOrderAmount
      subTotalDeliveryCharges
      subTotal1800platformfee
      subTotalDiscount
      subTotalProductAmount
      subTotalTax
      subTotalTipAmount
      saleDiscount
      updatedAt
      paymentIntentId
      paymentIntentRes
      updatedBy
      userId
      replaceOrder
    }
  }
`;

export const getOrder = /* GraphQL */ `
  query getOrder($id: ID!) {
    getOrder(id: $id) {
      orderShipment {
        items {
          id
          orderLineItems {
            productId
            productName
            qtyPurchased
            size
            totalPrice
            unitPrice
            storePosName
            storeSizeUom
            storeDisplayQty
            storeItemId
          }
          assignedStoreName
          deliveryAddress {
            addrLine1
            addrLine2
            city
            country
            state
            postCode
          }
          deliveryType
          shipmentStatus
        }
      }
      id
      orderStatus
      totalAmount
      totalDiscount
      stripeCustomerId
    }
  }
`;

export const onReplaceOrderShipmentNotification = /* GraphQL */ `
  subscription onReplaceOrderShipmentNotification($merchantAccountId: String) {
    onReplaceOrderShipmentNotification(merchantAccountId: $merchantAccountId) {
      messageStatus
    }
  }
`;

export const onAddStripeCheckoutWebhook = /* GraphQL */ `
  subscription onAddStripeCheckoutWebhook( $merchantAccountId: String) {
  onAddStripeCheckoutWebhook(merchantAccountId: $merchantAccountId) {
  email
	amount_capturable
	amount_received
	payment_intent_id
	stripe_event_type
	deliverytype
	fullName
	phoneNumber
  assignedStoreId
  merchantAccountId
    }
  }
`;

export const searchProductsQuery = /* GraphQL */ `
  query searchProducts(
    $filter: SearchableProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    searchProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        prodFullName
        prodName
        prodCategory
        imageFile
        brandLine
        manufacturer
        prodMinor
        region
        abv
      }
      nextToken
      brand {
        key
        doc_count
      }
      ProdCategory {
        key
        doc_count
      }
      manufacturer {
        key
        doc_count
      }
    }
  }
`;
export const searchProductsLamdaQuery = /* GraphQL */ `
  query searchProductsLambda(
    $merchantAccountId: String
    $filter: SearchableProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    searchProductsLambda(
      filter: $filter
      merchantAccountId: $merchantAccountId
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        prodFullName
        prodName
        prodCategory
        imageFile
        price
        brandLine
        manufacturer
        prodMinor
        region
        abv
      }
      nextToken
    }
  }
`;
export const getMerchantAccount = /* GraphQL */ `
  query getMerchantAccount($id: ID!) {
    getMerchantAccount(id: $id) {
      billingAddress {
        addrLine2
        state
        postCode
        addrLine1
        city
        country
      }
      contactEmail
      companyName
      contactName
      isinbrand_group
      in_geography
      brand_groupName
      brand_groupGeography
      in_brand_groupName
      isabrand_group
      accountDetails {
        accountNumber
        bankName
        midNumber
        routingNumber
      }
    }
  }
`;

export const getUser = /* GraphQL */ `
  query GetUser($userName: String!) {
    getUser(userName: $userName) {
      userName
      name
      email
      phoneNumber
      createdAt
      updatedAt
      owner
    }
  }
`;

export const listUsers = /* GraphQL */ `
  query ListUsers(
    $userName: String
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUsers(
      userName: $userName
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        userName
        name
        email
        phoneNumber
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;

export const getAddress = /* GraphQL */ `
  query GetAddress($id: ID!) {
    getAddress(id: $id) {
      id
      addrLine1
      addrLine2
      addrLine3
      city
      state
      country
      postCode
      latitude
      longitude
      createdAt
      updatedAt
      owner
    }
  }
`;

export const listAddresss = /* GraphQL */ `
  query ListAddresss(
    $filter: ModelAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAddresss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        addrLine1
        addrLine2
        addrLine3
        city
        state
        country
        postCode
        latitude
        longitude
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;

// export const getMerchantAccount = /* GraphQL */ `
//   query GetMerchantAccount($id: ID!) {
//     getMerchantAccount(id: $id) {
//       id
//       companyName
//       contactName
//       contactPhoneNumber
//       contactEmail
//       billingAddress {
//         id
//         addrLine1
//         addrLine2
//         addrLine3
//         city
//         state
//         country
//         postCode
//         latitude
//         longitude
//         createdAt
//         updatedAt
//         owner
//       }
//       accountSatus
//       accountStatusReason
//       approvedAt
//       approvedBy
//       Stores {
//         nextToken
//       }
//       createdAt
//       updatedAt
//       owner
//     }
//   }
// `;

export const getUserStores = /* GraphQL */ `
  query getUserStores($userId: ID!) {
    getMerchantUser(userId: $userId) {
      userId
      firstName
      lastName
      stores {
        items {
          id
          store {
            id
            storeName
          }
        }
      }
    }
  }
`;

export const listStoresForOptions = /* GraphQL */ `
  query listStores {
    listStores {
      items {
        id
        displayName
        storeName
      }
    }
  }
`;

export const listMerchantAccounts = /* GraphQL */ `
  query ListMerchantAccounts(
    $filter: ModelMerchantAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMerchantAccounts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyName
        contactName
        contactPhoneNumber
        contactEmail
        accountSatus
        accountStatusReason
        approvedAt
        approvedBy
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;

export const getStore = /* GraphQL */ `
  query GetStore($id: ID!) {
    getStore(id: $id) {
      id
      storeRefId
      storeName
      storeEmail
      storeLogo
      addLoyalCustomers
      storePhoneNumber
      address {
        # id
        addrLine1
        addrLine2
        city
        state
        country
        postCode
        latitude
        longitude
        # createdAt
        # updatedAt
        # owner
      }
      merchantAccountId
      regBusinessHours {
        Reg
      }
      businessHours {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
      }
      regDeliveryHours {
        Reg
      }
      deliveryHours {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
      }
      scheduleHours {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
      }
      merchantAccount {
        id
        companyName
        contactName
        contactPhoneNumber
        contactEmail
        # accountSatus
        accountStatusReason
        approvedAt
        approvedBy
        # createdAt
        # updatedAt
        # owner
      }
      users {
        items {
          id
          user {
            userId
            email
            firstName
            lastName
          }
        }
      }
      holidays {
        Description
        endDate
        startDate
      }
      orderFulfilling {
        pickUp
        delivery
        gifting
      }
      giftWrapping
      deliveryScope {
        serviceArea
        MinOrderSize
        deliveryType
        deliveryPartner
      }
      deliveryFeeConfig {
        from
        to
        deliveryFee
      }
        serviceAreaConfig {
        from
        to
        MinOrderSize
      }
      merchantFeeConfig {
        from
        to
        merchantFee
        merchantFeeToCustomer
      }
      customerConvenienceFeePercentage
      enableMerchantConvenienceFeePercentage
      enableConvenienceFeePercentage
      merchantConvenienceFeePercentage
      automaticDiscountConfig {
        category
        size
        uom
        quantity
        discount
        discountFlatAmount
      }
      isRefundAllowed
      refundSetup {
        refundTimeline
        driverTips
        deliveryFee
        productPriceAndTax
        cardProcessingFee
        restockingFee
        restockingPercent
      }
      automaticDiscountFlag
      creditCardProcessingPercent
      creditCardProcessingFlatFee
      chargeAdditionalCardFee
      getEmail
      storeSubDomain
      aboutStore
      taxRate
      taxThroughStripe
      merchantFee
      merchantFeeToCustomer
      # status
      destinationAccountID
      specialProdCat
      carriersAllowed
      statusReason
      doordashStoreId
	doordashBusinessId
      statusUpdatedAt
      statusUpdatedBy
      storePhotos
      couponCode {
        promoCode
        issueCategory
        issuedDate
        expiryDate
        expiryDateTime
        budget
        used
        usedPercent
        codeType
        createdAt
        createdBy
        updatedAt
        updatedBy
        codeDescription
        maxCouponValue
        appliedCount
        codeValidity
        categoryType
        issuedByStoreId
        issuedByCustomerId
        issuedByUser
        issuedToCustomerId
        freeCouponsThisPeriod
        codeApplicability
      }
      createdAt
      updatedAt
      # owner
    }
  }
`;

export const listSearchStores = /* GraphQL */ `
  query ListStores($storeName: String) {
    listStores(filter: { displayName: { contains: $storeName } }) {
      items {
        id
        storeLogo
        storeRefId
        storeEmail
        storePhoneNumber
        storeName
        address {
          addrLine1
          addrLine2
          state
          postCode
          city
          country
          latitude
          longitude
        }
      }
    }
  }
`;

export const listStores = /* GraphQL */ `
  query ListStores(
    $filter: ModelStoreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStores(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storeRefId
        storeLogo
        storeName
        merchantAccountId
        statusReason
        storePhoneNumber
        storeEmail
        storePhotos
        specialProdCat
        deliveryFee
        destinationAccountID
        creditCardProcessingPercent
        creditCardProcessingFlatFee
        chargeAdditionalCardFee
        merchantFee
        getEmail
        merchantFeeToCustomer
        posSoftware
        users {
          items {
            user {
              firstName
              lastName
            }
            id
          }
        }
        giftWrapping
        deliveryScope {
          deliveryType
          serviceArea
          MinOrderSize
        }
        regDeliveryHours {
          Reg
        }
        deliveryHours {
          Fri
          Mon
          Sat
          Sun
          Thu
          Tue
          Wed
        }
        carriersAllowed
        orderFulfilling {
          delivery
          gifting
          pickUp
        }
        holidays {
          Description
          endDate
          startDate
        }
        regBusinessHours {
          Reg
        }
        businessHours {
          Fri
          Mon
          Sat
          Sun
          Thu
          Tue
          Wed
        }
        address {
          addrLine1
          addrLine2
          state
          postCode
          city
          country
          latitude
          longitude
        }

        # statusUpdatedAt
        # statusUpdatedBy

        # createdAt
        # updatedAt
        # owner
      }
      nextToken
    }
  }
`;

export const byEmail = /* GraphQL */ `
  query ByEmail(
    $email: AWSEmail
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        userName
        name
        email
        phoneNumber
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;

export const byName = /* GraphQL */ `
  query ByName(
    $name: String
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byName(
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        userName
        name
        email
        phoneNumber
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;

export const getS3SignedURL = /* GraphQL */ `
  query getS3SignedURL(
    $contentType: String!
    $fileName: String!
    $merchantAccountId: String!
    $requestType: String!
    $storeID: String
    $uploadType: String
  ) {
    getS3SignedURL(
      contentType: $contentType
      fileName: $fileName
      merchantAccountId: $merchantAccountId
      requestType: $requestType
      storeID: $storeID
      uploadType: $uploadType
    ) {
      fileName
      signedURL
    }
  }
`;

export const getMultipleSignedURL = /* GraphQL */ `
  query getMultipleSignedURL(
    $filesList: [S3FileType]!
    $merchantAccountId: String!
    $requestType: String!
    $storeID: String
  ) {
    getMultipleSignedURL(
      filesList: $filesList
      merchantAccountId: $merchantAccountId
      requestType: $requestType
      storeID: $storeID
    ) {
      items {
        fileName
        signedURL
      }
    }
  }
`;

export const searchAddress = /* GraphQL */ `
  query searchAddress($input: SearchAddressInput!) {
    searchAddress(input: $input) {
      items {
        city
        entries
        secondary
        state
        street_line
        zipcode
      }
    }
  }
`;

export const getMerchantBrandGroupNames = /* GraphQL */ `
  query getMerchantBrandGroupNames($brand_groupGeography: String!) {
    getMerchantBrandGroupNames(brand_groupGeography: $brand_groupGeography) {
      brands
    }
  }
`;

export const searchPriceNAvailabilitys = /* GraphQL */ `
  query searchPriceNAvailabilitys(
    $filter: SearchablePriceNAvailabilityFilterInput
    $sort: SearchablePriceAndAvailabilitySortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchPriceNAvailabilitys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        automaticDiscountConfig{
          category
          size
          uom
          quantity
          discount
          discountFlatAmount
        }
        salePrice
        storeId
        price
        uom
        size
        availableQty
        storeItemId
        storeItemLevel
        storeItemQty
        storeItemVintage
        sizeUom
        productName
        prodCategory
        upc
        prodFullName
      }
      nextToken
      total
    }
  }
`;

export const getCustomerProfile = /* GraphQL */ `
  query getCustomerProfile($userId: ID!) {
    getCustomerProfile(userId: $userId) {
      id
      phoneNumber
      firstName
      lastName
      middleName
      myReferralCode
      email
      userId
      orderId
      profileImage
      deliveryToId
      referredCode
      referredCustomerUserId
      subscribeToNotification
      customerId
      promoCodes {
        promoCode
        issued
        used
        issuedBy
        codeDescription
        codeApplicability
        codeCategory
        issuedDate
        expiryDate
        maxCouponValue
      }
    }
  }
`;

export const listOrderReport = /* GraphQL */ `
  query listOrderReport($merchantAccountId: String!) {
    listOrderReport(merchantAccountId: $merchantAccountId) {
      items {
        assignedStoreId
        assignedStoreName
        dateRange
        reportPath
        merchantAccountId
      }
    }
  }
`;
export const listLoyalOrderReport = /* GraphQL */ `
  query listLoyalOrderReport($merchantAccountId: String!) {
    listLoyalOrderReport(merchantAccountId: $merchantAccountId) {
      items {
        assignedStoreId
        assignedStoreName
        dateRange
        reportPath
        merchantAccountId
      }
    }
  }
`;

export const listUnmappedReport = /* GraphQL */ `
  query listUnmappedReport($merchantAccountId: String!) {
    listUnmappedReport(merchantAccountId: $merchantAccountId) {
      items {
        assignedStoreId
        assignedStoreName
        dateRange
        reportPath
        merchantAccountId
      }
    }
  }
`;
export const onAddOrderShipmentWebhook = /* GraphQL */ `
  subscription onAddOrderShipmentWebhook($pickup_phone_number: [String]) {
    onAddOrderShipmentWebhook(pickup_phone_number: $pickup_phone_number) {
      event_name
      external_delivery_id
      dasher_id
      dasher_name
      dasher_phone_number
      dasher_dropoff_phone_number
      dasher_pickup_phone_number
      pickup_address
      pickup_phone_number
      pickup_instructions
      pickup_external_business_id
      pickup_external_store_id
      order_value
      currency
      pickup_time_estimated
      dropoff_time_estimated
      fee
      tip
      support_reference
      tracking_url
      contactless
      shipmentStatus
    }
  }
`;

export const searchPriceNAvailabilityQueries = /* GraphQL */ `
  query searchPriceNAvailabilityQueries(
    $filter: SearchablePriceNAvailabilityFilterInput
    $bucketFilter: BucketFilterInput
    $sort: SearchablePriceAndAvailabilitySortInput
    $limit: Int
    $nextToken: String
    $from: Int
    $lat: Float
    $lon: Float
    $distance: Int
    $requestFrom: String
    $searchType: ProductSearchType
  ) {
    searchPriceNAvailabilityQueries(
      filter: $filter
      bucketFilter: $bucketFilter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      lat: $lat
      lon: $lon
      distance: $distance
      requestFrom: $requestFrom
      searchType: $searchType
    ) {
      items {
        id
        storeId
        price
        salePrice
        size
        uom
        prodCategory
        automaticDiscountConfig{
          category
          size
          uom
          quantity
          discount
          discountFlatAmount
        }
        automaticDiscountFlag
        availableQty
        storeItemId
        storeItemLevel
        storeItemQty
        storeItemVintage
        upc
        sizeUom
        productName
        prodFullName
        brandLine
        country
        prodMajor
        prodMinor
        packType
        container
	      containerFullDesc
        containerType
        productBrandRef
        manufacturer
        region
        appellation
        vintage
        varietal
        abv
        imageFile
        feature
        producer
        rawMaterials
        discountAmount
	discountPercent
  prodName
      }
      nextToken
      total
    }
  }
`;

export const fetchDocsFromES = /* GraphQL */ `
  query fetchDocsFromES(
    $filter: SearchablePriceNAvailabilityFilterInput
    $from: Int
    $lat: Float
    $lon: Float
    $distance: Int
  ) {
    fetchDocsFromES(
      filter: $filter
      from: $from
      lat: $lat
      lon: $lon
      distance: $distance
    ) {
      items {
        id
        storeId
        price
        salePrice
        size
        uom
        prodCategory
        automaticDiscountConfig{
          category
          size
          uom
          quantity
          discount
          discountFlatAmount
        }
        automaticDiscountFlag
        availableQty
        storeItemId
        storeItemLevel
        storeItemQty
        storeItemVintage
        upc
        sizeUom
        productName
        prodFullName
        brandLine
        country
        prodMajor
        prodMinor
        packType
        container
	      containerFullDesc
        containerType
        productBrandRef
        manufacturer
        region
        appellation
        vintage
        varietal
        abv
        imageFile
        feature
        producer
        rawMaterials
        discountAmount
        totalQty
        expiresAt
        updatedAt
	discountPercent
  prodName
      }
      nextToken
      total
    }
  }
`;